import {
  formatDate,
  MbscCalendarEvent,
  MbscDatepickerOptions,
  MbscEventcalendarOptions,
  MbscEventcalendarView,
  MbscPopup,
  MbscPopupOptions,
  momentTimezone,
} from '@mobiscroll/angular';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from 'src/app/services/appointment.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { forkJoin, Observable } from 'rxjs';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { data } from 'jquery';
import * as moment from 'moment-timezone';
import {
  SLOT_CONFIG,
  WORKING_TIME_CONFIG,
} from 'src/app/config/calendar.config';
momentTimezone.moment = moment;
//import * as moment from 'moment-timezone';

//momentTimezone.moment = moment;
const monthNames = [
  'Jan',
  'Feb',
  'March',
  'April',
  'May',
  'June',
  'July',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

@Component({
  selector: 'app-reschedule-appointments',
  templateUrl: './reschedule-appointments.component.html',
  styleUrls: ['./reschedule-appointments.component.scss'],
})
export class RescheduleAppointmentsComponent implements OnInit {
  locationId: any = '';
  apptId: any;
  apptDetails: any;
  comments: string = '';
  userRole: any;
  // appts: any;
  appointmentComments: any;
  show: boolean = false;
  scheduleId: any;
  diagId: any;
  UserDaigAdmin: any = [];
  @ViewChild('colorPicker', { static: false })
  colorPicker: any;
  resourceName: any;
  locationName: any;
  isApptCompleted: boolean = false;
  popupEventTitle: string | undefined;
  popupEventDescription = '';
  popupEventAllDay = true;
  popupEventDates: any;
  appointmentDetails: any = {};
  isEdit = false;
  diagnosticians: any;
  selectTimeSlots = 'slot1';
  selectedTime: any;
  selectedColor = '';
  calendarSelectedDate: any = new Date();
  myResources: any[] = [];
  locations: any;
  modalDisabled: boolean = true;
  diagAvailable: boolean = true;
  events: any;
  AppointmentForm!: FormGroup;
  apptSchedule: any;
  view: MbscEventcalendarView = {
    schedule: {
      type: 'week',
      allDay: false,
      startDay: 1,
      endDay: 7,
      startTime: WORKING_TIME_CONFIG.start,
      endTime: WORKING_TIME_CONFIG.end,
    },
  };

  invalid = [
    {
      start: '0001-01-00',
      end: new Date(new Date().setDate(new Date().getDate() - 1)),
    },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private auth: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private appointmentService: AppointmentService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.show = false;
    this.spinner.show();
    console.log('Page Open');
    this.userRole = this.auth.getUserType();
    this.activatedRoute.params.subscribe((params) => {
      this.apptId = params['id'];
    });
    this.appointmentService
      .getAppointments(null, null, null, this.apptId, null, null)
      .subscribe((data) => {
        this.apptDetails = data.data[0];
        this.locationId = this.apptDetails.appointmentDetails.locationId;
        this.diagId = this.apptDetails.appointmentDetails.diagnosticianId;
        this.resourceName =
          this.apptDetails.appointmentDetails.diagnosticianName;
        this.locationName = this.apptDetails.appointmentDetails.location;
        this.scheduleId =
          this.apptDetails.appointmentDetails.schedules[0].scheduleId;

        let schedules = this.apptDetails.appointmentDetails.schedules;

        console.log('schedules:', schedules[0]);

        if (schedules[0].schduleType == 'Appointment') {
          this.apptSchedule = schedules[0];

          console.log(
            'meeting type for Appointment :',
            this.apptSchedule.meetingType
          );
        }
      });

    this.AppointmentForm = this.formBuilder.group({
      locationId: [''],
      appointmentId: [''],
      start: [''],
      end: [''],
      diagnosticianId: [''],
      appointmentDate: [this.assessmentDate, Validators.required],
      appointmentTime: [this.appointmentTime, Validators.required],
      resource: [''],
      slot: [''],
      // assesmentComments: [''],
      // appointmentComments: [this.appointmentComments]
    });
    // for (let i in this.appts) {

    //   if (this.appts[i] == "" || this.appts[i] == null) {
    //     this.appts[i] = '-'
    //   }

    // }
    forkJoin({
      user: this.appointmentService.getUser(null, 1003),
      director: this.appointmentService.getUser(null, 1004),
    }).subscribe(({ user, director }) => {
      user.data.forEach((admin: any) => {
        this.UserDaigAdmin.push(admin);
      });

      director.data.forEach((dir: any) => {
        this.UserDaigAdmin.push(dir);
      });
    });

    this.appointmentService.getLocations().subscribe((requestTwo) => {
      this.locations = requestTwo;
    });

    this.show = true;
    this.spinner.hide();
    console.log('Page Close');
  }
  myEvents: MbscCalendarEvent[] = [];
  tempEvent!: MbscCalendarEvent;
  reset: any = 'Close';
  @ViewChild('popup', { static: false })
  popup!: MbscPopup;
  assessmentDate: any;
  appointmentTime!: string;
  selectedDiag!: string;
  clickToCreate: any = 'single';
  popupHeaderText!: string;
  popupAnchor: HTMLElement | undefined;
  popupAddButtons = [
    'cancel',
    {
      handler: () => {
        this.saveEvent();
      },
      keyCode: 'enter',
      text: 'Save',
      cssClass: 'mbsc-popup-button-primary',
    },
  ];
  popupEditButtons = [
    'cancel',
    {
      handler: () => {
        this.saveEvent();
      },
      keyCode: 'enter',
      text: 'Save',
      cssClass: 'mbsc-popup-button-primary',
    },
  ];
  popupButtons: any = [];
  popupOptions: MbscPopupOptions = {
    display: 'bottom',
    contentPadding: false,
    fullScreen: false,
    onClose: () => {
      if (!this.isEdit) {
        // refresh the list, if add popup was canceled, to remove the temporary event
        this.myEvents = [...this.myEvents];
      }
    },
    responsive: {
      xsmall: {
        display: 'anchored',
        touchUi: true,
      },
    },
  };
  calendarOptions: MbscEventcalendarOptions = {
    clickToCreate: this.clickToCreate,
    dragToCreate: true,
    dragToMove: false,
    dragToResize: false,
    view: {
      schedule: {
        type: 'week',
      },
    },
    timezonePlugin: momentTimezone,
    dataTimezone: 'utc',
    displayTimezone: 'America/Chicago',
    responsive: {
      medium: {
        dragToCreate: false,
      },
    },

    onEventClick: (args) => {
      this.isEdit = true;
      this.tempEvent = args.event;
      // fill popup form with event data
      if (this.tempEvent.title == 'New event') {
        this.loadPopupForm(args.event);
        // set popup options
        this.popupHeaderText = 'Edit event';
        this.popupButtons = this.popupEditButtons;
        this.popupAnchor = args.domEvent.currentTarget;
        // open the popup
        this.popup.open();
      }
    },
    onEventCreated: (args) => {
      setTimeout(() => {
        this.isEdit = false;
        this.tempEvent = args.event;
        this.selectedTime = this.tempEvent.start;

        this.loadPopupForm(args.event);
        // set popup options
        this.popupHeaderText = 'New Event';
        this.popupButtons = this.popupAddButtons;
        this.popupAnchor = args.target;
        // open the popup
        this.popup.open();
        // }
      });
    },
    onEventDeleted: (args) => {
      setTimeout(() => {
        this.deleteEvent(args.event);
      });
    },
    onEventUpdated: (args) => {
      // here you can update the event in your storage as well, after drag & drop or resize
      // ...
    },
  };
  loadPopupForm(event: MbscCalendarEvent): void {
    this.diagnosticians.data.forEach(
      (element: { id: string | number; firstName: any; lastName: any }) => {
        if (element.id == this.tempEvent.resource) {
          this.resourceName = element.firstName + ' ' + element.lastName;
        }
      }
    );
    this.popupEventTitle = event.title;
    this.popupEventDescription = event['description'];
    this.popupEventDates = [event.start, event.end];
    this.popupEventAllDay = event.allDay || false;
    let d = new Date(event.start as Date);
    let hours = d.getHours();
    if (
      hours >= SLOT_CONFIG.slot1.start.hour &&
      hours < SLOT_CONFIG.slot1.end.hour
    ) {
      this.selectTimeSlots = 'slot1';
    } else {
      this.selectTimeSlots = 'slot2';
    }
    this.selectedColor = event.color || '';
  }

  onDeleteClick(): void {
    if (this.reset == 'Reset') {
      this.deleteEvent(this.tempEvent);
      this.popup.close();
    }
  }

  // onSaveClick(): void {
  //  console.log(this.diagnosticians.data.);
  //   this.selectedDiag!=this.tempEvent.resource;
  //   console.log("selectedDiag     "+this.tempEvent.resource);

  // }
  deleteEvent(event: MbscCalendarEvent): void {
    if (this.reset == 'Reset') {
      this.myEvents = this.myEvents.filter((item) => item.id !== event.id);
      this.reset = 'Close';
      this.assessmentDate = '';
      this.appointmentTime = '';
      this.clickToCreate = 'single';
    }
  }
  saveEvent(): void {
    this.tempEvent.title = this.popupEventTitle;
    this.tempEvent['description'] = this.popupEventDescription;
    this.tempEvent.start = this.popupEventDates[0];

    this.tempEvent.end = this.popupEventDates[1];
    this.tempEvent.allDay = this.popupEventAllDay;
    this.tempEvent.slot = this.selectTimeSlots;

    const d = new Date(this.tempEvent.start as Date);

    let year = d.getFullYear();
    let monthName = monthNames[d.getMonth()];
    let day = d.getDate();

    this.assessmentDate = monthName + ' ' + day + ', ' + year;

    if (this.tempEvent.slot == 'slot1') {
      var start = new Date(this.tempEvent.start as Date);
      start.setDate(start.getDate());
      start.setHours(SLOT_CONFIG.slot1.start.hour);
      start.setMinutes(0);
      start.setMilliseconds(0);
      this.tempEvent.start = start;
      var end = new Date(this.tempEvent.end as Date);
      end.setDate(start.getDate());
      end.setHours(SLOT_CONFIG.slot1.end.hour);
      end.setMinutes(0);
      end.setMilliseconds(0);
      this.tempEvent.end = end;
      this.appointmentTime =
        SLOT_CONFIG.slot1.start.timeFormatted +
        ' - ' +
        SLOT_CONFIG.slot1.end.timeFormatted;
    } else if (this.tempEvent.slot == 'slot2') {
      var start = new Date(this.tempEvent.start as Date);
      start.setDate(start.getDate());
      start.setHours(SLOT_CONFIG.slot2.start.hour);
      start.setMinutes(0);
      start.setMilliseconds(0);
      this.tempEvent.start = start;
      var end = new Date(this.tempEvent.end as Date);
      end.setDate(start.getDate());
      end.setHours(SLOT_CONFIG.slot2.end.hour);
      end.setMinutes(0);
      end.setMilliseconds(0);
      this.tempEvent.end = end;
      this.appointmentTime =
        SLOT_CONFIG.slot2.start.timeFormatted +
        ' - ' +
        SLOT_CONFIG.slot2.end.timeFormatted;
    }

    this.tempEvent.color = this.selectedColor;
    if (this.isEdit) {
      // update the event in the list
      this.myEvents = [...this.myEvents];
      // here you can update the event in your storage as well
      // ...
    } else {
      // add the new event to the list
      this.myEvents = [...this.myEvents, this.tempEvent];
      // here you can add the event to your storage as well
      // ...
    }
    // navigate the calendar
    this.calendarSelectedDate = this.popupEventDates[0];
    this.reset = 'Reset';
    this.clickToCreate = '';

    // close the popup
    this.popup.close();
  }

  selectLocation() {
    // this.locationId=e.target.value;
    this.myEvents = [];
    if (this.tempEvent) {
      this.onDeleteClick();
    }
    this.show = false;
    this.spinner.show();

    let i = 0;
    let userType = 1002;
    this.myResources = [];
    this.locations.data.forEach((element: { id: any; name: any }) => {
      if (element.id == this.locationId) {
        this.locationName = element.name;
      }
    });

    forkJoin({
      requestOne: this.appointmentService.getUserV2(this.locationId, userType),
      requestTwo: this.appointmentService.getDiagUnavailability(
        null,
        this.locationId,
        userType
      ),
      requestThree: this.appointmentService.getAppointments(
        this.locationId,
        null,
        'ALL',
        null,
        null,
        null
      ),
    }).subscribe(({ requestOne, requestTwo, requestThree }) => {
      this.diagnosticians = requestOne;
      if (requestOne.data.length == 0) {
        this.modalDisabled = true;
        this.diagAvailable = false;
        this.show = true;

        this.spinner.hide();
      } else {
        this.modalDisabled = false;
        this.diagAvailable = true;

        this.diagnosticians.data.forEach((element: any) => {
          let requestOne = {
            id: element.id,
            name: element.firstName + ' ' + element.lastName,
            // img: 'https://img.mobiscroll.com/demos/m2.png',
          };
          this.myResources.push(requestOne);
        });

        this.events = requestTwo;
        this.events.data.forEach((element: any) => {
          this.invalid.push(element);
        });
        this.events.dataRec.forEach((element: any) => {
          this.invalid.push(element);
        });

        requestThree.data.forEach((element: any) => {
          let appt = element.appointmentDetails.schedules[0];
          if (appt.status != 'CANCEL') {
            this.myEvents.push(appt);
          }
        });

        this.show = true;
        this.spinner.hide();
      }
    });
  }

  submitForm() {
    this.spinner.show();
    this.AppointmentForm.controls['appointmentId'].setValue(this.apptId);
    this.AppointmentForm.controls['locationId'].setValue(this.locationId);

    this.AppointmentForm.controls['resource'].setValue(this.tempEvent.resource);
    if (this.tempEvent.slot == 'slot1') {
      this.AppointmentForm.controls['slot'].setValue(1);
    } else if (this.tempEvent.slot == 'slot2') {
      this.AppointmentForm.controls['slot'].setValue(2);
    }
    var startDate = new Date(this.tempEvent.start as Date);
    // var userTimezoneOffset = startDate.getTimezoneOffset() * 60000;
    //  startDate = new Date(startDate.getTime() - userTimezoneOffset);

    var endDate = new Date(this.tempEvent.end as Date);
    // var userTimezoneOffset = endDate.getTimezoneOffset() * 60000;
    //  endDate = new Date(endDate.getTime() - userTimezoneOffset);
    this.AppointmentForm.controls['start'].setValue(startDate);
    this.AppointmentForm.controls['end'].setValue(endDate);

    this.appointmentDetails['reschduleDetails'] = this.AppointmentForm.value;
    // this.appointmentDetails['parentDetails'] = this.parentDetailsForm.value;

    // console.log(this.AppointmentForm);
    this.appointmentService
      .rescheduleAppointment(this.appointmentDetails)
      .subscribe(
        (res: any) => {
          // console.log(res);
          if (res.code == '500') {
            this.spinner.hide();
            return;
          }
          this.spinner.hide();
          this.router.navigate(['/appt-all-details', this.apptId]);
          // jQuery('#paymentModal').modal('show');
          // this.testAmount = res.data.totalAmount;
          // this.clientId = res.data.clientId;
          // this.appointmentId = res.data.appointmentId;
        },
        (err) => {
          this.spinner.hide();
        }
      );
  }

  getMeetingType(meetingType: string) {
    if (meetingType) {
      return meetingType;
    } else {
      return 'NA';
    }
  }
}
